/**
 * Created by showzyl on 2017/3/3.
 */

;(function () {
	'use strict';

	// var mv_default_data = {
	// 	"banner": "../../img/roll/banner3.png",
	// 	"banner2": "../../img/roll/banner3.png",
	// 	"home_url": "banner 用",
	// 	"brand_desc": "<strong>OUTSTANDING ORDINARY: </strong> New line launched! New fun styles, and more BAGS",
	// 	"picture": [{
	// 		"image": "../../img/roll/pic1.jpg",
	// 		"desc": "<strong><span style='color: red;'>35% OFF </span>&nbsp; | &nbsp; ENTRY REVES</strong> <br><span class='desc'>Free shipping on all items</span>",
	// 		"deeplink": ""
	// 	}, {
	// 		"image": "../../img/roll/pic2.jpg",
	// 		"desc": "<strong><span style='color: red;'>20% OFF </span>&nbsp; | &nbsp; ENTRE REVES</strong> <br><span class='desc'>Free shipping on all items</span>",
	// 		"deeplink": ""
	// 	}, {
	// 		"image": "../../img/roll/pic3.jpg",
	// 		"desc": "<strong><span style='color: red;'>15% OFF </span>&nbsp; | &nbsp; ENTRE REVES</strong> <br><span class='desc'>Free shipping on all items</span>",
	// 		"deeplink": ""
	// 	}],
	// 	"share_facebook": "1",
	// 	"share_twitter": "1",
	// 	"share_instagram": 0,
	// 	"width": "320",
	// 	// "height": "50"
	// }

	var mv_default_data = {
		"banner": "https://hybird.rayjump.com/dsp/img/roll/banner3.png",
		"banner2": "https://hybird.rayjump.com/dsp/img/roll/banner3.png",
		"home_url": "http://www.mobvista.com/",
		"brand_desc": "<strong>OUTSTANDING ORDINARY: </strong> New line launched! New fun styles, and more BAGS",
		"picture": [{
			"image": "https://hybird.rayjump.com/dsp/img/roll/pic1.jpg",
			"desc": "<strong><span style='color: red;'>35% OFF </span>&nbsp; | &nbsp; ENTRY REVES</strong> <br><span class='desc'>Free shipping on all items</span>",
			"deeplink": "http://www.mobvista.com/"
		}, {
			"image": "https://hybird.rayjump.com/dsp/img/roll/pic2.jpg",
			"desc": "<strong><span style='color: red;'>20% OFF </span>&nbsp; | &nbsp; ENTRE REVES</strong> <br><span class='desc'>Free shipping on all items</span>",
			"deeplink": "http://www.mobvista.com/"
		}, {
			"image": "https://hybird.rayjump.com/dsp/img/roll/pic3.jpg",
			"desc": "<strong><span style='color: red;'>15% OFF </span>&nbsp; | &nbsp; ENTRE REVES</strong> <br><span class='desc'>Free shipping on all items</span>",
			"deeplink": "http://www.mobvista.com/"
		}],
		"share_facebook": "1",
		"share_twitter": "1",
		"share_instagram": 0,
		"width": "320",
		// "height": "50"
	}

	var defaultClick = 'click';

	document.addEventListener('DOMContentLoaded', function (event) {
		mv_util.addClass(mv_util.getEl('#mv_page_init'), 'mv_none');
		mv_util.addClass(mv_util.getEl('.mv_mask')[0], 'mv_none');
		var data = _.extend(mv_default_data, mv_data);
		//反转义
		data.brand_desc = mv_util.unescapeHTML(data.brand_desc);
		for (var i = 0; i < data.picture.length; i++) {
			data.picture[i].desc = mv_util.unescapeHTML(data.picture[i].desc)
		}
		handleRender(data);
	});

	var bInitSwiper = false;
	function handleRender(data) {
		var banner = mv_util.getEl('#mv_banner');
		var mv_roll = mv_util.getEl('#mv_roll');
		// 统计
		var stats = mv_util.getEl('.mv_stats');
		mv_common.stats(stats);

		if (data && mv_common.getTplSize(data)) {
			// only render banner
			mv_util.createEl('img', banner, {
				src: data.banner
			});
			banner.addEventListener(defaultClick, function () {
				mv_stats({
					category: 'Richmedia',
					action: 'click_photo_banner',
					label: data.width + '_' + data.height
				});
				try {
					mraid.expand();
				} catch (e) {

				}
				mv_util.rmClass(mv_roll, 'mv_none');
				mv_util.addClass(banner, 'mv_none');
				if(!bInitSwiper){
					var swiper = new Swiper('.swiper-container', {
						autoplay: 1000,
						slidesPerView: 'auto',
						paginationClickable: true,
						spaceBetween: 15
					});
					bInitSwiper = true;
				}
			})
		} else {
			mv_util.rmClass(mv_roll, 'mv_none');
			if(!bInitSwiper){
				setTimeout(function () {
					var swiper = new Swiper('.swiper-container', {
						autoplay: 1000,
						slidesPerView: 'auto',
						paginationClickable: true,
						spaceBetween: 15
					});
					bInitSwiper = true;
				}, 5);
			}
		}
		mvRender(data);
		bindEvent(data);
	}

	function mvRender(data) {
		var roll = mv_util.getEl('#mv_roll');
		var tpl = mv_util.getEl('#mv_tpl').innerHTML;
		if (data) {
			var sHtml = _.template(tpl)(data);
			roll.innerHTML = sHtml;
		}
	}

	function bindEvent(data) {
		var i;

		var click_url = mv_util.getEl('.click_url');
		for (i = 0; i < click_url.length; i++) {
			click_url[i].addEventListener(defaultClick, function () {
				var url = this.getAttribute('data-url');
				try {
					mraid.open(url);
				} catch (e) {
					window.open(url);
				}
			});
		}

		var notice_url = mv_util.getEl('.notice_url');
		for (i = 0; i < notice_url.length; i++) {
			notice_url[i].addEventListener(defaultClick, function () {
				var notice = this.getAttribute('data-notice');
				mv_util.createEl('script', '', {
					src: notice
				});
			})
		}

		var closeBtn = mv_util.getEl('#mv_close_btn');
		var mv_roll = mv_util.getEl('#mv_roll');
		var banner = mv_util.getEl('#mv_banner');
		closeBtn.addEventListener(defaultClick, function () {
			mv_util.addClass(mv_roll, 'mv_none');
			mv_util.rmClass(banner, 'mv_none');
		});

		try {
			mraid.addEventListener("stateChange", function (state) {
				if (state === 'expanded') {
					mv_util.addClass(banner, 'mv_none');
				} else {
					mv_util.rmClass(banner, 'mv_none');
				}
			});
		} catch (e) {

		}
		
		mv_common.share(data);
	}

	function mv_stats(cfg) {
		mv_common.gpStats(function () {
			var mv_ga = mv_util.getEl('#mv_ga');
			var param = mv_ga.getAttribute('data-param');
			param = JSON.parse(param);

			ga('set', {
				dimension1: param['offer'],
				dimension2: param['app'],
				dimension3: param['advertiser']
			});

			ga('send', {
				title: document.title,
				hitType: 'event',
				eventCategory: cfg.category, // 'Richmedia'
				eventAction: cfg.action, // 'Click_Roll_Banner'
				eventLabel: cfg.label // mv_data.width + mv_data.height
			});
		});
	}

	//调启ga统计
	mv_common.gpStats();

})(window);









